import { render, staticRenderFns } from "./CentralPayments.vue?vue&type=template&id=5c859e81"
import script from "./CentralPayments.vue?vue&type=script&lang=js"
export * from "./CentralPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports